export default __webpack_public_path__ + "static/media/31t.c6d2d0f2.jpg";